// @flow
export { getFbp as getFbpFromCookies } from './cookies';
